<!-- User dropdown -->
<div class="navbar-top-dropdown-container">
  <!-- Menu -->
  <button
    #userMenuTrigger="matMenuTrigger"
    class="navbar-top-dropdown-button-user pointer dropdown-toggle"
    [matMenuTriggerFor]="userMenu"
  >
    <div class="navbar-top-user-icon">
      <i class="fa fa-user-circle fa-fw"></i>
      <i
        class="fa fa-bell user-notification"
        [ngClass]="{
          'user-notification-active': pendingNotifications > 0,
          hidden: !pendingNotifications
        }"
      ></i>
    </div>
    <div class="navbar-top-user-name">
      <span
        [ngClass]="
          sessionUserName?.name?.length > 10
            ? 'navbar-top-dropdown-user-long'
            : 'navbar-top-dropdown-user'
        "
      >
        {{ sessionUserName?.name }}
      </span>
      <span
        [ngClass]="
          sessionUserName?.surname?.length > 10
            ? 'navbar-top-dropdown-user-long'
            : 'navbar-top-dropdown-user'
        "
      >
        {{ sessionUserName?.surname }}
      </span>
    </div>
    <app-arson-option-status />
  </button>

  <!-- User menu -->
  <mat-menu #userMenu="matMenu">
    <span
      (mouseleave)="userMenuActive = false; closeUserMenu()"
      (mouseenter)="userMenuActive = true"
    >
      <!-- ARSON -->
      @if (
        originalProfile == PROFILES.ARSON ||
        sessionProfile == PROFILES.ARSON ||
        originalProfile == PROFILES.USUARIO_ARSON ||
        sessionProfile == PROFILES.USUARIO_ARSON
      ) {
        <button
          #arsonUserMenuTrigger="matMenuTrigger"
          mat-menu-item
          [matMenuTriggerFor]="arsonUserMenu"
        >
          <mat-icon class="material-menu-icon"><i class="fas fa-user-lock"></i></mat-icon>
          <span>ARSON</span>
        </button>
      }
      <!-- Screen capture -->
      @if (sessionProfile != PROFILES.INSTALADOR) {
        <button
          #cameraUserMenuTrigger="matMenuTrigger"
          mat-menu-item
          [matMenuTriggerFor]="cameraUserMenu"
        >
          <mat-icon class="material-menu-icon"><i class="fas fa-video"></i></mat-icon>
          <span>{{ "screen-capture" | translate }}</span>
        </button>
      }
      <!-- Notifications -->
      @if (
        sessionProfile != PROFILES.ADMIN_INSTALLATION &&
        sessionProfile != PROFILES.INSTALADOR &&
        sessionProfile != PROFILES.TELEMEDIDA
      ) {
        <button mat-menu-item (click)="notificationModal.showNotifications()">
          <mat-icon
            class="material-menu-icon"
            [ngClass]="{ 'user-notification-active': pendingNotifications > 0 }"
          >
            <i class="fas fa-bell"></i>
          </mat-icon>
          <span>{{ "notifications" | translate }}</span>
          @if (pendingNotifications > 0) {
            <span>({{ pendingNotifications }})</span>
          }
        </button>
      }
      <!-- User list -->
      @if (
        allowList &&
        sessionProfile != PROFILES.USUARIO_ARSON &&
        sessionProfile != PROFILES.INSTALADOR &&
        sessionProfile != PROFILES.TELEMEDIDA
      ) {
        <button
          mat-menu-item
          [ngClass]="{
            hidden:
              sessionProfile != PROFILES.ARSON &&
              sessionProfile != PROFILES.ADMIN_CLIENTE &&
              sessionProfile != PROFILES.ADMIN_ENTIDAD &&
              sessionProfile != PROFILES.ADMIN_AGRUPACION &&
              sessionProfile != PROFILES.ADMIN_INSTALLATION,
            disabled: ENVIRONMENT.demo && sessionProfile != PROFILES.ARSON
          }"
          [routerLink]="['/usuarios/listado']"
        >
          <mat-icon class="material-menu-icon"><i class="fa fa-users"></i></mat-icon>
          <span>{{ "user-list" | translate }}</span>
        </button>
      }
      <!-- User log -->
      @if (
        !disableLog &&
        sessionProfile != PROFILES.ADMIN_INSTALLATION &&
        sessionProfile != PROFILES.INSTALADOR &&
        sessionProfile != PROFILES.TELEMEDIDA
      ) {
        <button
          #userLogMenuTrigger="matMenuTrigger"
          mat-menu-item
          [matMenuTriggerFor]="userLogMenu"
        >
          <mat-icon class="material-menu-icon"><i class="fas fa-list-alt"></i></mat-icon>
          <span>{{ "Log" | translate }}</span>
        </button>
      }
      <!-- Account settings -->
      <button mat-menu-item [routerLink]="['/usuarios/formulario/editar/', currentUserId]">
        <mat-icon class="material-menu-icon"><i class="fas fa-user-cog"></i></mat-icon>
        <span>{{ "user-configuration" | translate }}</span>
      </button>
      <!-- Local settings -->
      <button
        #localUserMenuTrigger="matMenuTrigger"
        mat-menu-item
        [matMenuTriggerFor]="localUserMenu"
      >
        <mat-icon class="material-menu-icon"><i class="fas fas fa-cog"></i></mat-icon>
        <span>{{ "user-local-configuration" | translate }}</span>
      </button>
      <hr class="material-menu-separator" />
      <!-- Relogin -->
      @if (sessionProfile == PROFILES.ARSON) {
        <button mat-menu-item (click)="relogin()">
          <mat-icon class="material-menu-icon"><i class="fas fa-sign-in-alt"></i></mat-icon>
          <span>{{ "relogin" | translate }}</span>
        </button>
      }
      <!-- Logout -->
      <button mat-menu-item (click)="logout()" class="option-highlighted-red">
        <mat-icon class="material-menu-icon"><i class="fa fa-sign-out-alt"></i></mat-icon>
        <span>{{ "logout" | translate }}</span>
      </button>
      <!-- Last login -->
      <span mat-menu-item class="last-login">
        <mat-icon class="material-menu-icon"><i class="fas fa-clock"></i></mat-icon>
        <span>{{ "last-login" | translate }}: {{ lastLoginParsed }}</span>
      </span>
    </span>
  </mat-menu>

  <!-- User log menu -->
  <mat-menu #userLogMenu="matMenu">
    <span
      (mouseenter)="userLogMenuActive = true"
      (mouseleave)="userLogMenuActive = false; closeUserMenu()"
    >
      <button mat-menu-item [routerLink]="['/usuarios/log/global']">
        <mat-icon class="material-menu-icon"><i class="fas fa-user"></i></mat-icon>
        <span>{{ "user" | translate }}</span>
      </button>
      <button mat-menu-item [routerLink]="['/usuarios/log/agrupacion']">
        <mat-icon class="material-menu-icon"><i class="fas fa-map"></i></mat-icon>
        <span>{{ "groups" | translate }}</span>
      </button>
    </span>
  </mat-menu>

  <!-- Camera menu -->
  <mat-menu #cameraUserMenu="matMenu">
    <span
      (mouseleave)="cameraMenuActive = false; cameraUserMenuTrigger.closeMenu(); closeUserMenu()"
      (mouseenter)="cameraMenuActive = true"
    >
      <!-- Controls -->
      <app-screen-recorder [recorderType]="'menu'" [recordData]="recordData"></app-screen-recorder>
    </span>
  </mat-menu>

  <!-- Local settings menu -->
  <mat-menu #localUserMenu="matMenu">
    <span
      (mouseenter)="localUserMenuActive = true"
      (mouseleave)="localUserMenuActive = false; closeUserMenu()"
    >
      <!-- Home page -->
      <button
        #mainPageMenuTrigger="matMenuTrigger"
        mat-menu-item
        [matMenuTriggerFor]="mainPageUserMenu"
        [ngClass]="{
          hidden:
            sessionProfile != PROFILES.ARSON &&
            sessionProfile != PROFILES.USUARIO_ARSON &&
            sessionProfile != PROFILES.ADMIN_CLIENTE &&
            sessionProfile != PROFILES.ADMIN_ENTIDAD &&
            sessionProfile != PROFILES.USUARIO_TELEMEDIDA
        }"
      >
        <mat-icon class="material-menu-icon"><i class="fas fa-display"></i></mat-icon>
        <span>{{ "main-page" | translate }}</span>
      </button>
      <!-- Language -->
      <button
        #languageMenuTrigger="matMenuTrigger"
        mat-menu-item
        [matMenuTriggerFor]="languageUserMenu"
      >
        <mat-icon class="material-menu-icon"><i class="fas fa-language"></i></mat-icon>
        <span>{{ "change-language" | translate }}</span>
      </button>
      <!-- Themes -->
      @if (sessionProfile == PROFILES.ARSON) {
        <button
          #themeMenuTrigger="matMenuTrigger"
          mat-menu-item
          [matMenuTriggerFor]="themeUserMenu"
        >
          <mat-icon class="material-menu-icon"><i class="fas fa-palette"></i></mat-icon>
          <span>{{ "themes" | translate }}</span>
        </button>
      }
      <!-- Number format -->
      <button
        #numberFormatMenuTrigger="matMenuTrigger"
        mat-menu-item
        [matMenuTriggerFor]="numberFormatUserMenu"
      >
        <mat-icon class="material-menu-icon">
          <i class="fas fa-calculator"></i>
        </mat-icon>
        <span>{{ "change-number-format" | translate }}</span>
      </button>
      <!-- Date format -->
      <button
        #dateFormatMenuTrigger="matMenuTrigger"
        mat-menu-item
        [matMenuTriggerFor]="dateFormatUserMenu"
      >
        <mat-icon class="material-menu-icon"><i class="fas fa-calendar-day"></i></mat-icon>
        <span>{{ "change-date-format" | translate }}</span>
      </button>
      <hr class="material-menu-separator" />
      <!-- Reset map settings -->
      <button mat-menu-item (click)="resetMapSettings()" class="option-highlighted-red">
        <mat-icon class="material-menu-icon"><i class="fas fa-map"></i></mat-icon>
        <span>{{ "reset-map-settings" | translate }}</span>
      </button>
      <!-- Delete local profile -->
      <button mat-menu-item (click)="deleteUserLocalSettings()" class="option-highlighted-red">
        <mat-icon class="material-menu-icon"><i class="fas fa-eraser"></i></mat-icon>
        <span>{{ "user-local-configuration-delete" | translate }}</span>
      </button>
    </span>
  </mat-menu>

  <!-- Number format selector -->
  <mat-menu #numberFormatUserMenu="matMenu">
    <span
      (mouseenter)="localUserMenuActive = true"
      (mouseleave)="
        localUserMenuActive = false; numberFormatMenuTrigger.closeMenu(); closeUserMenu()
      "
    >
      <!-- Europeo -->
      <button
        mat-menu-item
        (click)="switchFormatNumber(LANGUAGE.ESPANOL)"
        [ngClass]="{
          'navbar-current-profile': numberFormat == 'es'
        }"
      >
        <mat-icon class="material-menu-icon">
          <img class="user-mat-menu-img" src="{{ 'assets/img/languages/eu-flag.png' }}" />
        </mat-icon>
        <span>
          XX
          <span class="navbar-decimal-separator">.</span>
          XXX
          <span class="navbar-decimal-separator">,</span>
          xx
        </span>
      </button>
      <!-- UK -->
      <button
        mat-menu-item
        (click)="switchFormatNumber(LANGUAGE.INGLES)"
        [ngClass]="{
          'navbar-current-profile': numberFormat == 'en'
        }"
      >
        <mat-icon class="material-menu-icon">
          <img class="user-mat-menu-img" src="{{ 'assets/img/languages/uk-flag.png' }}" />
        </mat-icon>
        <span>
          XX
          <span class="navbar-decimal-separator">,</span>
          XXX
          <span class="navbar-decimal-separator">.</span>
          xx
        </span>
      </button>
    </span>
  </mat-menu>

  <!-- Date format selector -->
  <mat-menu #dateFormatUserMenu="matMenu">
    <span
      (mouseenter)="localUserMenuActive = true"
      (mouseleave)="localUserMenuActive = false; dateFormatMenuTrigger.closeMenu(); closeUserMenu()"
    >
      <!-- Europeo -->
      <button
        mat-menu-item
        (click)="switchFormatDate('DD/MM/YYYY')"
        [ngClass]="{
          'navbar-current-profile': dateFormat == 'DD/MM/YYYY'
        }"
      >
        <mat-icon class="material-menu-icon">
          <img class="user-mat-menu-img" src="{{ 'assets/img/languages/eu-flag.png' }}" />
        </mat-icon>
        {{ "date-europe" | translate }}
      </button>
      <!-- UK -->
      <button
        mat-menu-item
        (click)="switchFormatDate('MM/DD/YYYY')"
        [ngClass]="{
          'navbar-current-profile': dateFormat == 'MM/DD/YYYY'
        }"
      >
        <mat-icon class="material-menu-icon">
          <img class="user-mat-menu-img" src="{{ 'assets/img/languages/usa-flag.png' }}" />
        </mat-icon>
        {{ "date-usa" | translate }}
      </button>
    </span>
  </mat-menu>

  <!-- Theme selector -->
  <mat-menu #themeUserMenu="matMenu">
    <span
      (mouseenter)="localUserMenuActive = true"
      (mouseleave)="localUserMenuActive = false; closeUserMenu(); closeUserMenu()"
    >
      <!-- Default -->
      <button
        mat-menu-item
        (click)="updateTheme('default')"
        [ngClass]="{
          'navbar-current-profile': sessionTheme == 'default'
        }"
      >
        <span>{{ "theme-default" | translate }}</span>
      </button>
      <!-- Agua -->
      <button
        mat-menu-item
        (click)="updateTheme('water')"
        [ngClass]="{
          'navbar-current-profile': sessionTheme == 'water'
        }"
      >
        <span>{{ "theme-water" | translate }}</span>
      </button>
      <!-- Gas -->
      <button
        mat-menu-item
        (click)="updateTheme('gas')"
        [ngClass]="{
          'navbar-current-profile': sessionTheme == 'gas'
        }"
      >
        <span>{{ "theme-gas" | translate }}</span>
      </button>
      <!-- Nortegas -->
      <button
        mat-menu-item
        (click)="updateTheme('nortegas')"
        [ngClass]="{
          'navbar-current-profile': sessionTheme == 'nortegas'
        }"
      >
        <span>Nortegas</span>
      </button>
      <!-- Oscuro -->
      <!-- <button
        mat-menu-item
        (click)="updateTheme('dark')"
        [ngClass]="{
          'navbar-current-profile': sessionTheme == 'dark'
        }"
      >
        <span>{{ "theme-dark" | translate }}</span>
      </button> -->
      <!-- High contrast -->
      <button
        mat-menu-item
        (click)="updateTheme('highContrast')"
        [ngClass]="{
          'navbar-current-profile': sessionTheme == 'highContrast'
        }"
      >
        <span>{{ "theme-high-contrast" | translate }}</span>
      </button>
    </span>
  </mat-menu>

  <!-- Language selector -->
  <mat-menu #languageUserMenu="matMenu">
    <span
      (mouseenter)="localUserMenuActive = true"
      (mouseleave)="localUserMenuActive = false; languageMenuTrigger.closeMenu(); closeUserMenu()"
    >
      <!-- Castellano -->
      <button
        mat-menu-item
        (click)="switchLanguage(LANGUAGE.ESPANOL)"
        [ngClass]="{
          'navbar-current-profile': currentLanguage == LANGUAGE.ESPANOL
        }"
      >
        <mat-icon class="material-menu-icon">
          <img class="user-mat-menu-img" src="{{ 'assets/img/languages/spain-flag.png' }}" />
        </mat-icon>
        <span>Castellano</span>
      </button>
      <!-- English -->
      <button
        mat-menu-item
        (click)="switchLanguage(LANGUAGE.INGLES)"
        [ngClass]="{
          'navbar-current-profile': currentLanguage == LANGUAGE.INGLES
        }"
      >
        <mat-icon class="material-menu-icon">
          <img class="user-mat-menu-img" src="{{ 'assets/img/languages/uk-flag.png' }}" />
        </mat-icon>
        <span>English</span>
      </button>
      <!-- Catalan -->
      <button
        mat-menu-item
        (click)="switchLanguage(LANGUAGE.CATALAN)"
        [ngClass]="{
          'navbar-current-profile': currentLanguage == LANGUAGE.CATALAN
        }"
      >
        <mat-icon class="material-menu-icon">
          <img class="user-mat-menu-img" src="{{ 'assets/img/languages/cat-flag.png' }}" />
        </mat-icon>
        <span>Catalá</span>
      </button>
      <!-- French -->
      <button
        mat-menu-item
        (click)="switchLanguage(LANGUAGE.FRANCES)"
        [ngClass]="{
          'navbar-current-profile': currentLanguage == LANGUAGE.FRANCES
        }"
      >
        <mat-icon class="material-menu-icon">
          <img class="user-mat-menu-img" src="{{ 'assets/img/languages/france-flag.png' }}" />
        </mat-icon>
        <span>Français</span>
      </button>
      <!-- Italiano -->
      <button
        mat-menu-item
        (click)="switchLanguage(LANGUAGE.ITALIANO)"
        [ngClass]="{
          'navbar-current-profile': currentLanguage == LANGUAGE.ITALIANO
        }"
      >
        <mat-icon class="material-menu-icon">
          <img class="user-mat-menu-img" src="{{ 'assets/img/languages/it-flag.png' }}" />
        </mat-icon>
        <span>Italiano</span>
      </button>
      <!-- Griego -->
      <button
        mat-menu-item
        (click)="switchLanguage(LANGUAGE.GRIEGO)"
        [ngClass]="{
          'navbar-current-profile': currentLanguage == LANGUAGE.GRIEGO
        }"
      >
        <mat-icon class="material-menu-icon">
          <img class="user-mat-menu-img" src="{{ 'assets/img/languages/el-flag.png' }}" />
        </mat-icon>
        <span>Ελληνικά</span>
      </button>
      <!-- Português -->
      <button
        mat-menu-item
        (click)="switchLanguage(LANGUAGE.PORTUGUES)"
        [ngClass]="{
          'navbar-current-profile': currentLanguage == LANGUAGE.PORTUGUES
        }"
      >
        <mat-icon class="material-menu-icon">
          <img class="user-mat-menu-img" src="{{ 'assets/img/languages/pt-flag.png' }}" />
        </mat-icon>
        <span>Português</span>
      </button>
    </span>
  </mat-menu>

  <!-- Main page selector -->
  <mat-menu #mainPageUserMenu="matMenu">
    <span
      (mouseenter)="localUserMenuActive = true"
      (mouseleave)="localUserMenuActive = false; mainPageMenuTrigger.closeMenu(); closeUserMenu()"
    >
      <!-- Agroupation -->
      <button
        mat-menu-item
        (click)="updateMainPage('/principal-agrupacion')"
        [ngClass]="{
          'navbar-current-profile': $safeNavigationMigration(mainPage?.includes('agrupacion'))
        }"
      >
        <mat-icon class="material-menu-icon"><i class="fas fa-map"></i></mat-icon>
        <span>{{ "agrupation" | translate }}</span>
      </button>
      <!-- Telemetry (only for USUARIO_TELEMEDIDA) -->
      @if (sessionProfile == PROFILES.USUARIO_TELEMEDIDA) {
        <button
          mat-menu-item
          (click)="updateMainPage('/telecontrol/telemedida')"
          [ngClass]="{
            'navbar-current-profile': $safeNavigationMigration(mainPage?.includes('telemedida'))
          }"
        >
          <mat-icon class="material-menu-icon"><i class="fas fa-tachometer-alt"></i></mat-icon>
          <span>{{ "telemetry" | translate }}</span>
        </button>
      }
      <!-- Entities -->
      @if (
        sessionProfile != PROFILES.ADMIN_ENTIDAD && sessionProfile != PROFILES.USUARIO_TELEMEDIDA
      ) {
        <button
          mat-menu-item
          (click)="updateMainPage('/principal-entidades')"
          [ngClass]="{
            'navbar-current-profile': $safeNavigationMigration(mainPage?.includes('entidades'))
          }"
        >
          <mat-icon class="material-menu-icon"><i class="fas fa-sitemap"></i></mat-icon>
          <span>{{ "client-management" | translate }}</span>
        </button>
      }
      <!-- Global -->
      @if (sessionProfile != PROFILES.USUARIO_TELEMEDIDA) {
        <button
          mat-menu-item
          (click)="updateMainPage('/principal-global')"
          [ngClass]="{
            'navbar-current-profile': $safeNavigationMigration(mainPage?.includes('global'))
          }"
        >
          <mat-icon class="material-menu-icon"><i class="fas fa-globe"></i></mat-icon>
          <span>{{ "client-summary" | translate }}</span>
        </button>
      }
    </span>
  </mat-menu>

  <!-- ARSON menu -->
  <mat-menu #arsonUserMenu="matMenu">
    <span
      (mouseenter)="arsonMenuActive = true"
      (mouseleave)="arsonMenuActive = false; closeUserMenu()"
    >
      <!-- Switch profile -->
      <button
        #profilesUserMenuTrigger="matMenuTrigger"
        mat-menu-item
        [matMenuTriggerFor]="profilesUserMenu"
      >
        <mat-icon class="material-menu-icon"><i class="fas fa-id-badge"></i></mat-icon>
        <span>{{ "change-profile" | translate }}</span>
      </button>
      @if (sessionProfile == PROFILES.ARSON) {
        <button
          mat-menu-item
          [attr.aria-pressed]="dataProtectionActive"
          (click)="toggleDataProtection()"
        >
          <mat-icon class="material-menu-icon data-protection-menu-icon">
            <i
              class="fa-solid fa-shield-halved"
              [class.text-success]="dataProtectionActive"
            ></i>
          </mat-icon>
          <span>{{ "toggle-data-protection" | translate }}</span>
        </button>
        <!-- Disable data restrictions -->
        <button
          mat-menu-item
          (click)="userRestrictionsActive = !userRestrictionsActive; updateUserRestrictions()"
        >
          <mat-icon class="material-menu-icon">
            <i
              [ngClass]="userRestrictionsActive ? 'fas fa-lock' : 'fas fa-lock-open'"
              [class.text-success]="userRestrictionsActive"
            ></i>
          </mat-icon>
          <span>{{ "toggle-data-restrictions" | translate }}</span>
        </button>
        <!-- Disable suspicions -->
        <button
          mat-menu-item
          (click)="userSuspicionActive = !userSuspicionActive; updateUserSuspicionActive()"
        >
          <mat-icon class="material-menu-icon suspicion-menu-icon">
            <i
              class="fas fa-circle-exclamation"
              [class.text-success]="userSuspicionActive"
              aria-hidden="true"
            ></i>
          </mat-icon>
          <span>{{ "toggle-suspicions" | translate }}</span>
        </button>
        <!-- Juegos -->
        <button mat-menu-item (click)="openGame()">
          <mat-icon class="material-menu-icon"><i class="fas fa-gamepad"></i></mat-icon>
          <span>Arson Games</span>
        </button>
      }
    </span>
  </mat-menu>

  <!-- Profile selector -->
  <mat-menu #profilesUserMenu="matMenu">
    <span
      (mouseenter)="arsonMenuActive = true"
      (mouseleave)="arsonMenuActive = false; profilesUserMenuTrigger.closeMenu(); closeUserMenu()"
    >
      <!-- ARSON -->
      @if (originalProfile == PROFILES.ARSON || sessionProfile == PROFILES.ARSON) {
        <button
          mat-menu-item
          [ngClass]="{
            'navbar-current-profile': sessionProfile == PROFILES.ARSON
          }"
          (click)="updateProfile('ARSON')"
        >
          <span>{{ "_profiles.1" | translate }}</span>
        </button>
      }
      <!-- ARSON user -->
      <button
        mat-menu-item
        [ngClass]="{
          'navbar-current-profile': sessionProfile == PROFILES.USUARIO_ARSON
        }"
        (click)="updateProfile('USUARIO_ARSON')"
      >
        <span>{{ "_profiles.16" | translate }}</span>
      </button>
      <!-- ADMIN_CLIENTE -->
      <button
        mat-menu-item
        [ngClass]="{
          'navbar-current-profile': sessionProfile == PROFILES.ADMIN_CLIENTE
        }"
        (click)="updateProfile('ADMIN_CLIENTE')"
      >
        <span>{{ "_profiles.2" | translate }}</span>
      </button>
      <!-- Client user -->
      <button
        mat-menu-item
        [ngClass]="{
          'navbar-current-profile': sessionProfile == PROFILES.USUARIO_CLIENTE
        }"
        (click)="updateProfile('USUARIO_CLIENTE')"
      >
        <span>{{ "_profiles.3" | translate }}</span>
      </button>
      <!-- ADMIN_ENTIDAD -->
      <button
        mat-menu-item
        [ngClass]="{
          'navbar-current-profile': sessionProfile == PROFILES.ADMIN_ENTIDAD
        }"
        (click)="updateProfile('ADMIN_ENTIDAD')"
      >
        <span>{{ "_profiles.4" | translate }}</span>
      </button>
      <!-- Entity user -->
      <button
        mat-menu-item
        [ngClass]="{
          'navbar-current-profile': sessionProfile == PROFILES.USUARIO_ENTIDAD
        }"
        (click)="updateProfile('USUARIO_ENTIDAD')"
      >
        <span>{{ "_profiles.5" | translate }}</span>
      </button>
      <!-- ADMIN_AGRUPACION -->
      <button
        mat-menu-item
        [ngClass]="{
          'navbar-current-profile': sessionProfile == PROFILES.ADMIN_AGRUPACION
        }"
        (click)="updateProfile('ADMIN_AGRUPACION')"
      >
        <span>{{ "_profiles.6" | translate }}</span>
      </button>
      <!-- Agroupation user -->
      <button
        mat-menu-item
        [ngClass]="{
          'navbar-current-profile': sessionProfile == PROFILES.USUARIO_AGRUPACION
        }"
        (click)="updateProfile('USUARIO_AGRUPACION')"
      >
        <span>{{ "_profiles.7" | translate }}</span>
      </button>
      <!-- ADMIN_INSTALLATION -->
      <button
        mat-menu-item
        [ngClass]="{
          'navbar-current-profile': sessionProfile == PROFILES.ADMIN_INSTALLATION
        }"
        (click)="updateProfile('ADMIN_INSTALLATION')"
      >
        <span>{{ "_profiles.12" | translate }}</span>
      </button>
      <!-- TELEMDIDA -->
      <button
        mat-menu-item
        [ngClass]="{
          'navbar-current-profile': sessionProfile == PROFILES.TELEMEDIDA
        }"
        (click)="updateProfile('TELEMEDIDA')"
      >
        <span>{{ "_profiles.14" | translate }}</span>
      </button>
      <!-- Telemetry user -->
      <button
        mat-menu-item
        [ngClass]="{
          'navbar-current-profile': sessionProfile == PROFILES.USUARIO_TELEMEDIDA
        }"
        (click)="updateProfile('USUARIO_TELEMEDIDA')"
      >
        <span>{{ "_profiles.18" | translate }}</span>
      </button>
    </span>
  </mat-menu>
</div>
